<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">大型仪器设备成果上报</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model="formInline.serial_no" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="serial_no" fixed label="设备编号" width="120">
        </custom-table-column>
        <custom-table-column prop="device_name" fixed label="设备名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属组织结构" width="180">
          <template slot-scope="scope" >
            <span>{{ scope.row.structure_1 }}{{ scope.row.structure_2 }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="case_name"  label="案例名称" min-width="180px">
        </custom-table-column>
        <custom-table-column prop="case_description"  label="案例描述" min-width="220px">
        </custom-table-column>
        <custom-table-column prop="achievement"  label="获得成果" min-width="220px">
        </custom-table-column>
        <custom-table-column label="相关材料" min-width="320">
          <template slot-scope="scope" v-if="scope.row.file_path">
            <el-link type="primary" v-for="(item,index) in scope.row.file_path.split(',')" :href="item" :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link>
          </template>
        </custom-table-column> 
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope" v-if="scope.row.status == 1">
            <el-button @click="handleEditNew(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="仪器设备" prop="new_device_individual_id">
          <el-cascader v-model="ruleForm.new_device_individual_id" filterable ref="cascader" :props="props"
            style="width:552px;" clearable :options="eqs"></el-cascader>
        </el-form-item>
        <el-form-item label="案例名称" prop="case_name">
          <el-input v-model="ruleForm.case_name" clearable placeholder="请输入" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item label="案例描述" prop="case_description">
          <el-input type="textarea" v-model="ruleForm.case_description" placeholder="请输入" style="width:552px;"
            :rows="4"></el-input>
        </el-form-item>
        <el-form-item label="获得成果" prop="achievement">
          <el-input type="textarea" v-model="ruleForm.achievement" placeholder="请输入" style="width:552px;"
            :rows="4"></el-input>
        </el-form-item>
        <el-form-item label="相关材料" prop="file_path" style="width:100%">
            <Uploadd ref="uploadd"  @setFileList="setUpFileList" @delFile="delUpFile"></Uploadd>
        </el-form-item> 
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';
import { mixinUpload } from '@/assets/js/mixin/upload';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinOrgan, mixinFormatter,mixinUpload],
  data() {
    return {
      formInline: {
        structure_1: '',
        structure_2: '',
        serial_no: '',
        device_name: '',
      },
      props: {
        emitPath: false
      },
      ruleForm: {
        new_device_individual_id:'',
        case_name: '',
        case_description: '',
        achievement: '',
        file_path: '',
      },
      fileFieldName: 'file_path',
      eqs: [],
      rules: {
        new_device_individual_id: [{ required: true, message: '请选择', trigger: 'change' }],
        // teaching_hours: [
        //   { required: true, message: '维修价格不能为空', trigger: 'blur' },
        //   { validator: this.checkfloat, trigger: 'blur' },
        // ],
      },
    };
  },
  components: {},
  created() {
    this.initEqs();
  },
  mounted() {
  },
  methods: {
    async initEqs() {
      await this.$store.dispatch('getEqs',{is_big_device:1})
      this.eqs = this.$store.state.allEqs.map(item => {
        let children = []
        if (item.individuals && item.individuals.length > 0) {
          children = item.individuals.map(child => {
            return {
              value: child.id,
              label: child.serial_no
            }
          })
        }
        return {
          value: item.id,
          label: item.device_name,
          children
        }
      })
    },
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/big/device/achievement/destroy/${this.delid}`, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/big/device/achievement/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/big/device/achievement/store', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/big/device/achievement/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.beforeQueryByKey("structure_1", "structure_2")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
